<mat-card class="form-container" id="createur_objet_maquette" appearance="outlined" data-tfa="creer_objet-maquette">
    <mat-card-title>
        @if (this.parentId()) {
        <h1>Ajouter un enfant sous {{ parent?.code }}</h1>
        } @else {
        <h1>Créer un objet maquette</h1>
        }
    </mat-card-title>
    <mat-card-content>
        @if (form) {
        <ng-container [formGroup]="form.asFormGroup">
            <div class="form-field-group">
                <!-- Champ "code" -->
                <mat-form-field class="form-field">
                    <mat-label>Code</mat-label>
                    <input
                        matInput
                        data-tfa="input_code_objet_maquette"
                        formControlName="code"
                        oninput="this.value = this.value.toUpperCase()"
                    />
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.code"></mat-error>
                    <mat-hint align="end"> {{ form.asFormGroup.controls.code.value?.length || 0 }} / 30 </mat-hint>
                </mat-form-field>
                <!-- Champ "typeObjetMaquette" -->
                <mat-form-field class="form-field">
                    <mat-label>Type Objet Maquette</mat-label>
                    <mat-select data-tfa="select_type_objet_maquette" formControlName="typeObjetMaquette">
                        @if (canBeFormation) {
                        <mat-option data-tfa="select_type_objet_maquette_FORMATION" [value]="TypeObjetMaquette.Formation"
                            >Formation</mat-option
                        >
                        }
                        <mat-option data-tfa="select_type_objet_maquette_OBJET-FORMATION" [value]="TypeObjetMaquette.ObjetFormation"
                            >Objet de formation</mat-option
                        >
                        @if (canBeGroupement) {
                        <mat-option data-tfa="select_type_objet_maquette_GROUPEMENT" [value]="TypeObjetMaquette.Groupement"
                            >Groupement</mat-option
                        >
                        }
                        <!-- Ajoutez d'autres options ici si nécessaire -->
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-field-group">
                @if (!isFormation) {
                <div
                    class="form-field center-toggle"
                    [matTooltip]="form.asFormGroup.controls.mutualise.disabled ? 'L\'objet sera mutualisé car le parent est mutualisé' : ''"
                >
                    <mat-checkbox id="mutualise-slide-toggle" data-tfa="mutualise-checkbox" formControlName="mutualise"
                        >Mutualisé</mat-checkbox
                    >
                </div>
                }
            </div>
            @if (isFormation) {
            <mat-form-field class="form-field" style="width: 100%;">
                <mat-label>Périmètres</mat-label>
                <mat-chip-grid #chipGrid aria-label="Ajouter un périmètre">
                    @for (perimetre of form.asFormGroup.controls.perimetres.value; track perimetre) {
                    <mat-chip-row
                        [editable]="false"
                        (removed)="removePerimetre(perimetre)"
                        [aria-description]="'périmètre ' + perimetre.code + ' ' + perimetre.libelle"
                        (click)="$event.stopImmediatePropagation()"
                    >
                        {{ perimetre.code }} {{ perimetre.libelle }}
                        <button
                            matChipRemove
                            [attr.aria-label]="'retirer le périmètre' + perimetre.code"
                            [attr.data-tfa]="'chip_' + perimetre"
                            [matTooltip]="'retirer ce périmètre'"
                            (click)="$event.stopImmediatePropagation()"
                        >
                            <mat-icon [attr.data-tfa]="'icon-remove_' + perimetre">cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                    }
                    <input
                        #perimetresInput
                        [matChipInputFor]="chipGrid"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)"
                        [matAutocomplete]="auto"
                        [formControl]="perimetresForm"
                        matInput
                        [placeholder]="
                            (mesPerimetres$ | async)?.length === 0
                                ? 'La formation est déjà associée à tous vos périmètres.'
                                : 'Rechercher un périmètre...'
                        "
                        data-tfa="input-perimetre"
                    />
                    <mat-autocomplete
                        #auto="matAutocomplete"
                        (optionSelected)="selected($event); perimetresInput.value = ''"
                        [hideSingleSelectionIndicator]="true"
                    >
                        @for (perimetre of mesPerimetres$ | async; track perimetre) {
                        <mat-option [value]="perimetre" [attr.data-tfa]="'option-perimetre_' + perimetre.code">
                            {{ perimetre.code }} {{ perimetre.libelle }}
                        </mat-option>
                        }
                    </mat-autocomplete>
                </mat-chip-grid>
            </mat-form-field>
            } @if (espaceSelected$ | async; as espace) {
            <app-formulaire-descripteurs-objet-maquette
                #descripteursObjetMaquetteComponent
                [typeObjetMaquette]="form.asFormGroup.controls.typeObjetMaquette.value"
                [hideSaveButton]="true"
                [espace]="espace"
            ></app-formulaire-descripteurs-objet-maquette>
            }
            <div class="form-field-group">
                <div class="center-button form-field">
                    <button data-tfa="objet-maquette-créer-annuler-button" mat-raised-button color="accent" (click)="annuler()">
                        <mat-icon data-tfa="icon-close">close</mat-icon>
                        Annuler
                    </button>
                    <button
                        data-tfa="objet-maquette-créer-button"
                        mat-raised-button
                        color="primary"
                        (click)="creer()"
                        [disabled]="!formIsValid()"
                    >
                        Créer
                    </button>
                </div>
            </div>
        </ng-container>
        }
    </mat-card-content>
</mat-card>
